import React from 'react';

interface ToastContextType {
  showToast: (message: string, top?: number) => void;
  // A toast with a button (e.g. Undo), up for longer so there's time to
  // reach it. Clicking it closes the toast. At the top by default, or in the
  // bottom right corner.
  showActionToast: (toast: {
    message: string;
    actionLabel: string;
    onAction: () => void;
    placement?: ToastPlacement;
  }) => void;
}

export type ToastPlacement = 'top' | 'bottom-right';

const ToastContext = React.createContext<ToastContextType>({
  showToast: () => '',
  showActionToast: () => {},
});

export default ToastContext;
